/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateFleetCommand,
  CreateFleetCommandResponse,
  FleetQueryResponse,
  GetFleetsParams,
  UpdateFleetCommandBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getFleets = (
    params: GetFleetsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<FleetQueryResponse>(
      {url: `/api/v1/fleets`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetFleetsQueryKey = (params: GetFleetsParams,) => {
    return [`/api/v1/fleets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetFleetsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFleets>>, GetFleetsParams['page']>, TError = ErrorType<unknown>>(params: GetFleetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData, Awaited<ReturnType<typeof getFleets>>, QueryKey, GetFleetsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFleetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFleets>>, QueryKey, GetFleetsParams['page']> = ({ signal, pageParam }) => getFleets({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData, Awaited<ReturnType<typeof getFleets>>, QueryKey, GetFleetsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFleetsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFleets>>>
export type GetFleetsInfiniteQueryError = ErrorType<unknown>


export function useGetFleetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFleets>>, GetFleetsParams['page']>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData, Awaited<ReturnType<typeof getFleets>>, QueryKey, GetFleetsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFleets>>,
          TError,
          Awaited<ReturnType<typeof getFleets>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFleetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFleets>>, GetFleetsParams['page']>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData, Awaited<ReturnType<typeof getFleets>>, QueryKey, GetFleetsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFleets>>,
          TError,
          Awaited<ReturnType<typeof getFleets>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFleetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFleets>>, GetFleetsParams['page']>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData, Awaited<ReturnType<typeof getFleets>>, QueryKey, GetFleetsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFleetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFleets>>, GetFleetsParams['page']>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData, Awaited<ReturnType<typeof getFleets>>, QueryKey, GetFleetsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFleetsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetFleetsQueryOptions = <TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(params: GetFleetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFleetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFleets>>> = ({ signal }) => getFleets(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFleetsQueryResult = NonNullable<Awaited<ReturnType<typeof getFleets>>>
export type GetFleetsQueryError = ErrorType<unknown>


export function useGetFleets<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFleets>>,
          TError,
          Awaited<ReturnType<typeof getFleets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFleets<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFleets>>,
          TError,
          Awaited<ReturnType<typeof getFleets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFleets<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFleets<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFleetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetFleetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(params: GetFleetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFleetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFleets>>> = ({ signal }) => getFleets(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFleetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFleets>>>
export type GetFleetsSuspenseQueryError = ErrorType<unknown>


export function useGetFleetsSuspense<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFleetsSuspense<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFleetsSuspense<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFleetsSuspense<TData = Awaited<ReturnType<typeof getFleets>>, TError = ErrorType<unknown>>(
 params: GetFleetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFleets>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFleetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createFleet = (
    createFleetCommand: BodyType<CreateFleetCommand>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateFleetCommandResponse>(
      {url: `/api/v1/fleets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFleetCommand, signal
    },
      options);
    }
  


export const getCreateFleetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,{data: BodyType<CreateFleetCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,{data: BodyType<CreateFleetCommand>}, TContext> => {
    
const mutationKey = ['createFleet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleet>>, {data: BodyType<CreateFleetCommand>}> = (props) => {
          const {data} = props ?? {};

          return  createFleet(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof createFleet>>>
    export type CreateFleetMutationBody = BodyType<CreateFleetCommand>
    export type CreateFleetMutationError = ErrorType<unknown>

    export const useCreateFleet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,{data: BodyType<CreateFleetCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createFleet>>,
        TError,
        {data: BodyType<CreateFleetCommand>},
        TContext
      > => {

      const mutationOptions = getCreateFleetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateFleet = (
    id: number,
    updateFleetCommandBody: BodyType<UpdateFleetCommandBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/fleets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateFleetCommandBody
    },
      options);
    }
  


export const getUpdateFleetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,{id: number;data: BodyType<UpdateFleetCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,{id: number;data: BodyType<UpdateFleetCommandBody>}, TContext> => {
    
const mutationKey = ['updateFleet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleet>>, {id: number;data: BodyType<UpdateFleetCommandBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleet(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleet>>>
    export type UpdateFleetMutationBody = BodyType<UpdateFleetCommandBody>
    export type UpdateFleetMutationError = ErrorType<unknown>

    export const useUpdateFleet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,{id: number;data: BodyType<UpdateFleetCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateFleet>>,
        TError,
        {id: number;data: BodyType<UpdateFleetCommandBody>},
        TContext
      > => {

      const mutationOptions = getUpdateFleetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteFleet = (
    id: number,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/fleets/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteFleetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFleet>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFleet>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteFleet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFleet>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteFleet(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFleetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFleet>>>
    
    export type DeleteFleetMutationError = ErrorType<unknown>

    export const useDeleteFleet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFleet>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteFleet>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteFleetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    